import { AutogenModelQuoteCustomer, AutogenRowQuoteCustomer } from "./autogen/AutogenModelQuoteCustomer";

export class ModelQuoteCustomer extends AutogenModelQuoteCustomer<RowQuoteCustomer> {
	constructor() {
		super(RowQuoteCustomer);
	}
}

export class RowQuoteCustomer extends AutogenRowQuoteCustomer {
}